'use strict';
import {createEventHandler, mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';
import {parseNumberEvent} from '../../../../../core-utilities/react-form-utils';
import {TextShortFieldEditView} from './TextShortFieldEditView';


export const StreamedComponent = (props$) => {
  const {
    handler: onChange,
    stream: fieldChange$,
  } = createEventHandler();

  fieldChange$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([ev, props]) => {
      const {options} = props.field;

      const result = options.isNumber ? parseNumberEvent(ev, 0) : ev.target.value;

      const event = {
        target: {
          value: result,
        },
      };

      props.onChange([props.field.id, event]);
    });

  return props$
    .combineLatest(
      (props) => ({
        ...props,
        onChange,
      }));
};

export const TextShortFieldEditComponent = mapPropsStream(StreamedComponent)(TextShortFieldEditView);



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/TextShortFieldEdit/TextShortFieldEditComponent.js